var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"banners"}},[(_vm.isAddingObject)?_c('SmartBanner'):(_vm.isSharing)?_c('ShareBanner'):_c('RegularBanner')],1)}
var staticRenderFns = []

export { render, staticRenderFns }